import React, { Component } from 'react';
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import SignupOrganisation from './SignupOrganisation';
import texts from '../../data/texts';

class Signup extends Component {

  constructor(props){
    super(props);
    this.state = {
      email: '',
      valid: false,
      error: false,
      show: false,
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if(!this.state.valid){
      this.setState({error: 'Bitte gib eine gültige E-Mail-Adresse ein.'});
    }

    const url = process.env.REACT_APP_API_HOST;

    const params = new URLSearchParams({
      email: this.state.email,
      data: ''
    });

    if(this.state.valid) {
      fetch(url+"/pro/subscribe", {
				method: 'post',
				body: params
			}).then(() =>
        this.setState({
          email: '',
          valid: false,
          show: false,
          error: false
        })
      );
    }
  }

  validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  handleKey = (e) => {
    this.setState({
      email: e.target.value,
      valid: this.validateEmail(e.target.value)
    });
  }

  toggle = () => {
    this.setState({show: !this.state.show});
  }

  render(){
    return (
      <React.Fragment>
        <Button color="primary" className={ this.props.className || "shadow-sm" } onClick={() => this.setState({show: true})}>{ texts.cta_text }</Button>
        <Modal isOpen={this.state.show} toggle={this.toggle} size="lg" className="modal-dialog-centered border-0">
          <ModalBody className="bg-secondary text-center p-0 shadow">
            <Button color="link" onClick={this.toggle} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
              <i className="fas fa-times" style={{ color: '#c8c8c8' }}></i>
            </Button>
            <Container className="p-3 p-md-5">
              <Row className="justify-content-md-center">
                <Col xs="12" lg="10">

                  <img src='/imgs/paul_logo_color_small.svg' style={{width: '80px', height: 'auto'}} className='mb-4' />
                  { this.state.submit
                  ?
                    <div>
                      <div className='notification is-success'>
                        <h2 className="text-white mb-3">Vielen Dank für Ihr Interesse an Paul!</h2>
                        <p className="text-white mb-5">Nach dem offiziellen Start des Services erhalten Sie einen Gutscheincode um sich den Startpreis zu suchern!</p>
                      </div>
                    </div>
                  :
                    <div className="pb-3">
                      <h2 className="text-white mb-2">{ texts.signup.modal_headline }</h2>
                      <h5 className="text-white mb-5">{ texts.signup.modal_subline }</h5>
                      <div className="input-group shadow">
                        <input className='form-control' type="email" placeholder={ texts.signup.email_placeholder } onKeyUp={(e) => this.handleKey(e)}/>
                        <div className='input-group-append'>
                          <button
                            className='btn btn-primary btn-block'
                            type='button'
                            onClick={this.handleSubmit}
                            value={this.state.email}
                          >{ texts.signup.modal_button }
                          </button>
                        </div>
                      </div>
                      {this.state.error && <small id="emailHelp" className="form-text text-left mt-2">{ this.state.error }</small>}
                    </div>
                  }

                </Col>
              </Row>
            </Container>

            <Container fluid className="bg-secondary-dark p-4">
              <p className="text-white font-weight-bold mb-3">{texts.orga_cta_headline}</p>
              <SignupOrganisation sublineText={true} />
            </Container>

          </ModalBody>
          <ModalFooter className="bg-white text-center justify-content-center">
            <small className="text-secondary" dangerouslySetInnerHTML={{__html: texts.signup.small_text.join('<br />')}}></small>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/components/modals/Signup.js